import * as React from 'react';
import { StyledStoreButton } from './styles';
import { Image } from '../Image';

import appstoreIcon from '../../assets/images/appleStore.png';
import googleIcon from '../../assets/images/googleStore.png';

import { IStoreButton } from './index';

// TODO: maybe rename prop type - not clear naming
const StoreButton: React.FC<IStoreButton> = ({ type, link = '#', maxWidth, className, mb, dataLocator, alt }) => {
  const imageSrc = type === 'apple' ? appstoreIcon : googleIcon;

  return (
    <StyledStoreButton
      href={link}
      target="_blank"
      className={className}
      mb={mb}
      rel="noreferrer noopener"
      data-locator={dataLocator}
    >
      <Image alt={alt ?? type} src={imageSrc} maxWidth={maxWidth} />
    </StyledStoreButton>
  );
};

export { StoreButton };
